import { render, staticRenderFns } from "./sp-main.vue?vue&type=template&id=36530e6b&scoped=true"
import script from "./sp-main.vue?vue&type=script&lang=js"
export * from "./sp-main.vue?vue&type=script&lang=js"
import style0 from "./sp-main.vue?vue&type=style&index=0&id=36530e6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36530e6b",
  null
  
)

export default component.exports